import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[spv2DragAndDrop]'
})
export class DragAndDropDirective {

  constructor(public elementRef: ElementRef, private renderer: Renderer2) { }

  @HostBinding('class.fileover') fileOver: boolean;
  @Output() fileDropped = new EventEmitter<any>();
  @Input('isSingleUpload') isSingleUpload;

  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }
   
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
  }

  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    let files = evt.dataTransfer.files;
    if(this.isSingleUpload){
      this.fileDropped.emit([files[0]]);
      return;
    }
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
